// extracted by mini-css-extract-plugin
export var baseButton = "_vd-0";
export var controlsArrowKeys = "_vd-1";
export var controlsResetButton = "_vd-2";
export var lightGameButton = "_vd-4 _vd-0";
export var playAgainButton = "_vd-5 _vd-0";
export var startGameButton = "_vd-3 _vd-0";